var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-gantt',{attrs:{"tasks":_vm.tasks,"config":_vm.config,"sortColumn":_vm.sortColumn,"isAscending":_vm.isAscending,"taskColors":_vm.taskColors,"taskInfo":_vm.taskInfo,"dataFormat":_vm.dataFormat},on:{"onTaskClick":_vm.onTaskClick}})}
var staticRenderFns = []

export { render, staticRenderFns }